<ngx-spinner [fullScreen]="false"
             [name]="'spinner' + spinnerId"
             bdColor="rgba(51,51,51,0.8)"
             color="#fff"
             size="medium"
             type="ball-clip-rotate-multiple"></ngx-spinner>
<div class="k-customied-grid" fxLayout="column" fxLayoutAlign="stretch">
  <kendo-grid #grid
              (columnReorder)="onReorder($event)"
              (columnResize)="onResize($event)"
              (columnVisibilityChange)="onVisibilityChange($event)"
              (dataStateChange)="onDataStateChange($event)"
              (pageChange)="onPageChange($event)"
              [columnMenu]="true"
              [data]="gridSettings.gridData"
              [filter]="gridSettings.state.filter"
              [pageable]="true"
              [pageSize]="gridSettings.state.take"
              [reorderable]="true"
              [resizable]="true"
              [skip]="gridSettings.state.skip"
              [sort]="gridSettings.state.sort"
              [sortable]="true"
              filterable="menu">
    > 
    <ng-template *ngIf="kendoGridToolbar" kendoGridToolbarTemplate>

      <button *ngIf="isCopy" (click)="onCopyEvent(selected)"
              [disabled]="checkCopyDisabled()"
              class="k-button k-button-md k-rounded-md k-button-solid-base k-button-solid"
              type="button">
        Copy
      </button>

      <button *ngIf="isExportExcel" class="k-button-md"
              kendoGridExcelCommand
              type="button">
        Export to Excel
      </button>
      <button *ngIf="clearFiltersBtn" (click)="onClearFilter()"
              class="k-button k-button-md k-rounded-md k-button-solid-base k-button-solid"
              type="button">
        Clear Filters
      </button>
      <button class="k-button k-button-md k-rounded-md k-button-solid-base k-button-solid"
              disabled="disabled"
              type="button"
              [ngClass]="filtered ? 'filtered' : ''">
        <div class="btnicon">
          <fa-icon icon="filter" matTooltipPosition="above"></fa-icon>
        </div>
        <div class="btntext">
          {{ filtered ? 'Filters Active' : 'No Active Filters' }}
        </div>
      </button>
      <kendo-grid-spacer></kendo-grid-spacer>
      <kendo-grid-spacer></kendo-grid-spacer>
      <kendo-grid-spacer></kendo-grid-spacer>
      <kendo-grid-spacer></kendo-grid-spacer>
      <kendo-grid-spacer></kendo-grid-spacer>
      <button *ngIf="resetBtn" (click)="onResetColumn()"
              class="k-button k-button-md k-rounded-md k-button-solid-base k-button-solid"
              type="button">
        Reset Column Settings
      </button>

    </ng-template>
    
    <kendo-grid-messages columnMenu=""> </kendo-grid-messages>
    <kendo-grid-messages [noRecords]="noRecordsMessage ? noRecordsMessage : 'No records available.'">
    </kendo-grid-messages>
    
    <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                       [field]="col.field"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [includeInChooser]="
        col.includeInChooser === null || col.includeInChooser === undefined
          ? 'true'
          : col.includeInChooser
      "
                       [title]="col.title"
                       [width]="col.width">
      <ng-template kendoGridHeaderTemplate>
        <span [title]="col.title">
          {{ col.title }}
        </span>
      </ng-template>
      <ng-template *ngIf="col.filter === 'currency' || col.filter === 'numeric'" kendoGridFilterMenuTemplate
                   let-column="column"
                   let-filter
                   let-filterService="filterService">
        <kendo-grid-numeric-filter-menu [column]="column"
                                        [filter]="filter"
                                        [filterService]="filterService"
                                        [extra]="false"
                                        operator="gte">
          <kendo-filter-gte-operator></kendo-filter-gte-operator>
          <kendo-filter-gt-operator></kendo-filter-gt-operator>
          <kendo-filter-eq-operator></kendo-filter-eq-operator>
          <kendo-filter-neq-operator></kendo-filter-neq-operator>
          <kendo-filter-lte-operator></kendo-filter-lte-operator>
          <kendo-filter-lt-operator></kendo-filter-lt-operator>
        </kendo-grid-numeric-filter-menu>
      </ng-template>
      <ng-template *ngIf="col.filter === 'date'" kendoGridFilterMenuTemplate
                   let-column="column"
                   let-filter
                   let-filterService="filterService">
        <kendo-grid-date-filter-menu [column]="column"
                                     [filter]="filter"
                                     [filterService]="filterService"
                                     [format]="col.format"
                                     [extra]="false"
                                     operator="gte">
          <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
          <kendo-filter-after-operator></kendo-filter-after-operator>
          <kendo-filter-eq-operator></kendo-filter-eq-operator>
          <kendo-filter-neq-operator></kendo-filter-neq-operator>
          <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
          <kendo-filter-before-operator></kendo-filter-before-operator>
        </kendo-grid-date-filter-menu>
      </ng-template>

      <ng-template *ngIf="col.filter === 'multicheck'" kendoGridFilterMenuTemplate
                   let-column="column"
                   let-filter="filter"
                   let-filterService="filterService">
        <teranet-grid-multicheck-filter-menu [currentFilter]="filter"
                                             [data]="getPrimitiveMultiSelect(col.field)"
                                             [field]="col.field"
                                             [filterService]="filterService"
                                             [format]="col.format"
                                             [isPrimitive]="true"
                                             [type]="col.type"></teranet-grid-multicheck-filter-menu>
      </ng-template>

      <ng-template *ngIf="!col.filter" kendoGridFilterMenuTemplate
                   let-column="column"
                   let-filter
                   let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column"
                                       [filter]="filter"
                                       [filterService]="filterService"
                                       [extra]="false"
                                       operator="eq">
          <kendo-filter-eq-operator></kendo-filter-eq-operator>
          <kendo-filter-neq-operator></kendo-filter-neq-operator>
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
          <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
          <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
          <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
      }
      <ng-template *ngIf="col.routerLink" kendoGridCellTemplate let-dataItem>
        <span [ngClass]="dataItem && dataItem.isFontBold ? 'bold' : ''">
          <a [queryParams]="getQueryParams(dataItem, col.routerLink)"
             [title]="dataItem[col.field]"
             routerLink="{{ col.routerLink }}">
            {{ dataItem[col.field] }}
          </a>
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'boolean1'" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field] ? 'TRUE' : ''" [id]="col.id ? col.id : col.title">
          {{ dataItem[col.field] ? 'TRUE' : '' }}
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'currency'" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field] | currency" [id]="col.id ? col.id : col.title">
          {{ dataItem[col.field] | currency }}
        </span>
      </ng-template>
      <ng-template *ngIf="col.type === 'assignStatus'" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field]">
          {{
            dataItem[col.field]===-1
              ? ''
              : (dataItem[col.field]===1?'Completed':(
              dataItem[col.field]===2?'Not Required':(
              dataItem[col.field]===3?'Assign':''
            )
          ))
          }}
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'queueStatus'" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field]">
          {{
      dataItem[col.field]===-1
        ? 'New'
        : (dataItem[col.field]===1?'New':(
        dataItem[col.field]===2?'Under Review':(
        dataItem[col.field]===3?'Completed':'New'
      )
    ))
          }}
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'date' || col.type === 'dateUTC'" kendoGridCellTemplate let-dataItem>
        <span [title]="
            !dataItem[col.field]
              ? ''
              : (dataItem[col.field] | date: (!col.format ? 'yyyy-MM-dd' : col.format))
          ">
          {{
            !dataItem[col.field]
              ? ''
              : (dataItem[col.field] | date: (!col.format ? 'yyyy-MM-dd' : col.format))
          }}
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'radio'" kendoGridCellTemplate let-dataItem>
        <input (click)="onSelectedEvent(dataItem)"
               [checked]="dataItem.id === selected"
               kendoRadioButton
               type="radio" />
      </ng-template>

      <ng-template *ngIf="col.type === 'status'" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field]"
              [id]="col.id ? col.id : col.title"
              [ngClass]="getNgClass(dataItem[col.field], col.okStatus)">
          {{ dataItem[col.field] }}
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'titlecase'" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field] | titlecase" [id]="col.id ? col.id : col.title">
          {{ dataItem[col.field] | titlecase }}
        </span>
      </ng-template>

      <ng-template *ngIf="col.type === 'delete'" kendoGridCellTemplate let-dataItem>
        <span (click)="onDeleteEvent(dataItem)" class="hover-pointer">
          <fa-icon [id]="dataItem[col.field]"
                   [icon]="col.icon"
                   class="fa fa-lg"
                   matTooltipPosition="above"></fa-icon>
        </span>
      </ng-template>
      <ng-template *ngIf="!col.type" kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem[col.field]" [id]="col.id ? col.id : col.title">
          {{ dataItem[col.field] }}
        </span>
      </ng-template>

    </kendo-grid-column>
    
    <kendo-grid-column *ngIf="iconColumnSettings.length > 0" [includeInChooser]="false" [width]="iconColumnWidth" title="Action">
      <ng-template kendoGridCellTemplate let-dataItem>

        <span class="hover-pointer"
               *ngFor="let col of iconColumnSettings"
              [field]="col.field"
              [id]="'icon' + col.title"
              [title]="col.title"
              (click)="col.clickAction(dataItem, dataItem[col.services])">
          <fa-icon [id]="dataItem[col.field]"
                   [icon]="col.icon"
                   class="fa fa-lg"
                   matTooltipPosition="above">
          </fa-icon>
        </span>
        }
      </ng-template>
    </kendo-grid-column>
    
    <ng-template kendoPagerTemplate
                 let-totalPages="totalPages"
                 let-currentPage="currentPage"
                 let-total="total">
      <div [class]="
          totalPages === 0 ? 'k-customied-grid-pagging-padding-top' : 'k-customied-grid-pagging'
        "
           fxLayoutGap="10px"
           fxLayout="row"
           fxLayoutAlign="space-between center">
        <div id="gridTotal">{{ total | number: '1.0':'en-US' }} total</div>

        <div *ngIf="totalPages > 0" class="k-pager-info">
          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons></kendo-pager-next-buttons>
        </div>
      </div>
    </ng-template>
    <kendo-grid-excel [fileName]="excelFileName()" [fetchData]="allData">
      
      <kendo-excelexport-column [field]="col.field"
                                *ngFor="let col of excelColumnSettings"
                                [title]="col.title"
                                [width]="col.width"
                                [cellOptions]="{ format: !col.format ? 'General' : col.format }">
      </kendo-excelexport-column>
      
    </kendo-grid-excel>
  </kendo-grid>
</div>
